module.exports = __webpack_public_path__ + "img/Ersa-SMARTFLOW2020-01-900x675.a2fa04a1.png";